import Render from 'components/render';
import useTheme from 'hooks/useTheme';

const RocketIcon = () => {
  const { isLightTheme } = useTheme();
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width={94}
      height={98}
      fill="none"
      data-palette="RocketIcon">
      <g filter="url(#RocketIconA)">
        <circle cx={47} cy={47} r={36} fill="var(--secondaryBackground)" />
      </g>
      <path
        fill="var(--secondaryText)"
        d="M46.955 54.537a.9.9 0 0 1-.46-.13c-1.913-1.174-3.15-4.253-3.15-7.846 0-1.802.318-3.513.918-4.95a.88.88 0 0 1 .81-.54h3.763c.354 0 .674.213.81.54.6 1.435.917 3.147.917 4.95 0 3.593-1.236 6.672-3.149 7.846a.87.87 0 0 1-.46.13m-1.275-11.71c-.375 1.105-.578 2.408-.578 3.734 0 2.924.892 5.02 1.853 5.98.96-.96 1.852-3.055 1.852-5.98 0-1.327-.203-2.63-.578-3.733zm1.276 32.11a.88.88 0 0 1-.878-.878V59.36a.878.878 0 1 1 1.756 0v14.698a.88.88 0 0 1-.878.878m-8.285-7.923a.88.88 0 0 1-.879-.878V49.157a.878.878 0 1 1 1.756 0v16.979a.877.877 0 0 1-.878.877m16.571 1.491a.877.877 0 0 1-.878-.878V50.647a.877.877 0 1 1 1.757 0v16.979a.88.88 0 0 1-.879.878"
      />
      <path
        fill="var(--favoriteStarFill)"
        d="M53.484 42.828h-13.06a.88.88 0 0 1-.81-.54c-1.972-4.72-3.014-10.372-3.014-16.342C36.6 14.398 40.576 4.2 46.495.569a.88.88 0 0 1 .919 0c5.918 3.63 9.894 13.83 9.894 25.377 0 5.972-1.043 11.622-3.014 16.342a.88.88 0 0 1-.81.54M41.016 41.07h11.876c1.74-4.396 2.66-9.612 2.66-15.125 0-10.477-3.512-20.04-8.598-23.58-5.087 3.54-8.599 13.103-8.599 23.58 0 5.512.92 10.728 2.66 15.125"
      />
      <path
        fill="var(--favoriteStarFill)"
        d="M31.964 47.698a.88.88 0 0 1-.878-.878v-8.552c0-.182.056-.36.162-.508l5.706-8.038a.878.878 0 0 1 1.591.431c.371 4.17 1.301 8.131 2.691 11.458a.88.88 0 0 1-.372 1.1l-8.462 4.87a.9.9 0 0 1-.438.117m.878-9.15v6.753l6.483-3.73c-1.049-2.698-1.82-5.748-2.268-8.96zm29.104 9.15a.87.87 0 0 1-.439-.118l-8.461-4.87a.88.88 0 0 1-.373-1.1c1.39-3.328 2.322-7.29 2.691-11.457a.878.878 0 0 1 1.59-.431l5.706 8.037a.9.9 0 0 1 .163.508v8.552a.876.876 0 0 1-.877.879m-7.362-6.128 6.483 3.731v-6.753l-4.215-5.937c-.446 3.21-1.217 6.26-2.268 8.96M46.955 27.56a5.917 5.917 0 0 1-5.911-5.91 5.92 5.92 0 0 1 5.91-5.91 5.92 5.92 0 0 1 5.911 5.91 5.917 5.917 0 0 1-5.91 5.91m0-10.065a4.16 4.16 0 0 0-4.155 4.154 4.16 4.16 0 0 0 4.155 4.154 4.16 4.16 0 0 0 4.154-4.154 4.16 4.16 0 0 0-4.154-4.155"
      />
      <Render when={isLightTheme}>
        <defs>
          <filter
            id="RocketIconA"
            width={94}
            height={94}
            x={0}
            y={4}
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              result="hardAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feMorphology
              in="SourceAlpha"
              operator="dilate"
              radius={1}
              result="effect1_dropShadow_436_7"
            />
            <feOffset dy={4} />
            <feGaussianBlur stdDeviation={5} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix values="0 0 0 0 0.68348 0 0 0 0 0.68348 0 0 0 0 0.68348 0 0 0 0.25 0" />
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_436_7" />
            <feBlend in="SourceGraphic" in2="effect1_dropShadow_436_7" result="shape" />
          </filter>
        </defs>
      </Render>
    </svg>)
  );
};
export default RocketIcon;
